import React, { Suspense } from 'react';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';

import ErrorPanel from '../widgets/error-panel.jsx';
import LoadSpinner from '../widgets/load-spinner.jsx';
import SideNavbar from '../widgets/side-navbar.jsx';
import TopicCommonView from './topic-common-view.jsx';

const AccountSettingsView = React.lazy(_ => import('./account-settings-view.jsx'));
import ContactsView from './contacts-view.jsx';
const CreateAccountView = React.lazy(_ => import('./create-account-view.jsx'));
import AccNotificationsView from './acc-notifications-view.jsx';
import AccSecurityView from './acc-security-view.jsx';
import AccSupportView from './acc-support-view.jsx';
import NewTopicView from './new-topic-view.jsx';
const PasswordResetView = React.lazy(_ => import('./password-reset-view.jsx'));
import SettingsView from './settings-view.jsx';
import ValidationView from './validation-view.jsx';
import SearchContacts from '../widgets/search-contacts.jsx';
import SearchOptions from '../widgets/search-options.jsx';
import NoMessages from '../widgets/no-messages.jsx';

// Panel titles for translation.
const messages = defineMessages({
  login: {
    id: 'sidepanel_title_login',
    description: 'Sidepanel title for LoginView.',
    defaultMessage: 'Sign In'
  },
  register: {
    id: 'sidepanel_title_register',
    description: 'Sidepanel title for CreateAccountView.',
    defaultMessage: 'Create Account'
  },
  settings: {
    id: 'sidepanel_title_settings',
    description: 'Sidepanel title for SettingsView.',
    defaultMessage: 'Settings'
  },
  edit: {
    id: 'sidepanel_title_account_settings',
    description: 'Sidepanel title for AccountSettingsView.',
    defaultMessage: 'Account Settings'
  },
  general: {
    id: 'panel_title_general',
    description: 'Title for TopicCommon.',
    defaultMessage: 'General'
  },
  security: {
    id: 'panel_title_security',
    description: 'Title for TopicSecirity and AccSecurity.',
    defaultMessage: 'Security'
  },
  crop: {
    id: 'panel_title_crop',
    description: 'Title for AvatarCropView.',
    defaultMessage: 'Drag to Adjust'
  },
  notif: {
    id: 'sidepanel_title_acc_notifications',
    description: 'Sidepanel title for AccNotificationsView.',
    defaultMessage: 'Notifications'
  },
  support: {
    id: 'sidepanel_title_acc_support',
    description: 'Sidepanel title for AccSupportView.',
    defaultMessage: 'Support'
  },
  newtpk: {
    id: 'sidepanel_title_newtpk',
    description: 'Sidepanel title for NewTopicView.',
    defaultMessage: 'Start New Chat'
  },
  newtpkgrp: {
    id: 'sidepanel_title_newtpkgrp',
    description: 'Sidepanel title for NewTopicViewGroup.',
    defaultMessage: 'Start New Group'
  },
  cred: {
    id: 'sidepanel_title_cred',
    description: 'Sidepanel title for ValidationView.',
    defaultMessage: 'Confirm Credentials'
  },
  reset: {
    id: 'sidepanel_title_reset',
    description: 'Sidepanel title for PasswordResetView.',
    defaultMessage: 'Reset Password'
  },
  archive: {
    id: 'sidepanel_title_archive',
    description: 'Sidepanel title for ContactsView-Archive.',
    defaultMessage: 'Archived Chats'
  },
  blocked: {
    id: 'sidepanel_title_blocked',
    description: 'Sidepanel title for ContactsView-Blocked.',
    defaultMessage: 'Blocked Chats'
  }
});

class SidepanelView extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleNewTopic = this.handleNewTopic.bind(this);
    this.handleNewTopicGroup = this.handleNewTopicGroup.bind(this);
  }

  handleNewTopic() {
    this.props.onNavigate('newtpk');
  }

  handleNewTopicGroup() {
    this.props.onNavigate('newtpkgrp');
  }

  render() {
    const { formatMessage } = this.props.intl;
    const view = this.props.state || 'contacts';

    let title, avatar, badges;
    if (view == 'contacts') {
      title = this.props.title;
      avatar = this.props.avatar ? this.props.avatar : true;
      badges = this.props.trustedBadges;
    } else {
      title = formatMessage(messages[view]);
      avatar = false;
      badges = null;
    }

    let onCancel;
    if (['login', 'contacts'].indexOf(view) == -1) {
      onCancel = this.props.onCancel;
    }

    return (
      <div id="sidepanel">
        <SideNavbar
          state={view}
          title={title}
          avatar={avatar}
          tinode={this.props.tinode}
          trustedBadges={badges}
          myUserId={this.props.myUserId}
          onSignUp={this.props.onSignUp}
          onSettings={this.props.onSettings}
          onNewTopic={this.handleNewTopic}
          onNewTopicGroup={this.handleNewTopicGroup}
          onCancel={onCancel}
          onShowDialog={this.props.onShowDialog}
          onMarkReadAllMessage={this.props.onMarkReadAllMessage}
          handleShowGroupMembers={this.props.handleShowGroupMembers}
        />
        <SearchContacts
          placeholder={formatMessage({
            id: 'sidepanel_search',
            defaultMessage: 'Search'
          })}
          onSearchContacts={this.props.onSearchContacts}
          tinode={this.props.tinode}
          chatList={this.props.chatList}
          topicSelected={this.props.topicSelected}
        />
        {/* <SearchOptions
          handleSetOptionSearch={this.props.handleSetOptionSearch}
          optionSearch={this.props.optionSearch}
        /> */}
        {/* <ErrorPanel
          level={this.props.errorLevel}
          text={this.props.errorText}
          action={this.props.errorAction}
          actionText={this.props.errorActionText}
        onClearError={this.props.onError} /> */}

        <LoadSpinner show={this.props.loadSpinnerVisible} />
        <div className="sidepanel-contact">
          <ContactsView
            tinode={this.props.tinode}
            myUserId={this.props.myUserId}
            connected={this.props.connected}
            topicSelected={this.props.topicSelected}
            archive={view == 'archive'}
            blocked={view == 'blocked'}
            chatList={this.props.chatList}
            showContextMenu={this.props.showContextMenu}
            onTopicSelected={this.props.onTopicSelected}
            onShowArchive={this.props.onShowArchive}
            searchResults={this.props.searchResults}
            onCreateTopic={this.props.onCreateTopic}
            handleSearchResultSelected={this.props.handleSearchResultSelected}
            handleSetOptionSearch={this.props.handleSetOptionSearch}
            optionSearch={this.props.optionSearch}
            search={this.props.search}
            isHideTopic={true}
            isShowTyping={true}
            isShowPin={true}
          />
          <NoMessages
            chatList={this.props.chatList}
            tinode={this.props.tinode}
            search={this.props.search}
            searchResults={this.props.searchResults}
            initCacheSuccess={this.props.initCacheSuccess}
          />
        </div>
      </div>
    );
  }
};

export default injectIntl(SidepanelView);
